var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetNeptune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: 225,
    cy: 225,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    id: "i",
    cx: 225,
    cy: 225,
    r: 225
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 225,
    fill: "#497EFA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356CEE",
    fillRule: "nonzero",
    d: "M317.177 262c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm-287 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm539 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-166c-6.627 0-12-5.373-12-12s5.373-12 12-12h166zm-334-96c6.628 0 12 5.373 12 12s-5.372 12-12 12h-78v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h160c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.628 0 12-5.373 12-12s-5.372-12-12-12h-30c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm168 36c0-6.627-5.372-12-12-12h-84c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.628 0 12 5.373 12 12s-5.372 12-12 12h-24v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h200c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h9c6.628 0 12-5.373 12-12zm-388-36c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm662 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356CEE",
    fillRule: "nonzero",
    d: "M317.177 118c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm-287 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm539 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-166c-6.627 0-12-5.373-12-12s5.373-12 12-12h166zm-334-96c6.628 0 12 5.373 12 12s-5.372 12-12 12h-78v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99V70h160c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.628 0 12-5.373 12-12s-5.372-12-12-12h-30c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm168 36c0-6.627-5.372-12-12-12h-84c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.628 0 12 5.373 12 12s-5.372 12-12 12h-24v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99V70h200c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h9c6.628 0 12-5.373 12-12zm-388-36c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm662 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156z",
    mask: "url(#d)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356CEE",
    fillRule: "nonzero",
    d: "M317.177 430c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm-287 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm539 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-166c-6.627 0-12-5.373-12-12s5.373-12 12-12h166zm-334-96c6.628 0 12 5.373 12 12s-5.372 12-12 12h-78v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h160c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.628 0 12-5.373 12-12s-5.372-12-12-12h-30c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm168 36c0-6.627-5.372-12-12-12h-84c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.628 0 12 5.373 12 12s-5.372 12-12 12h-24v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h200c6.628 0 12 5.373 12 12s-5.372 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12h9c6.628 0 12-5.373 12-12zm-388-36c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zm662 0c6.628 0 12 5.373 12 12s-5.372 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12h156z",
    mask: "url(#f)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2255CA",
    fillRule: "nonzero",
    d: "M148.177 274c0-6.627-5.372-12-12-12h-19c-6.627 0-12-5.373-12-12s5.373-12 12-12h79c6.628 0 12 5.373 12 12s-5.372 12-12 12h-3v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h3c6.628 0 12 5.373 12 12s-5.372 12-12 12h-61c-6.627 0-12-5.373-12-12s5.373-12 12-12h1c6.628 0 12-5.373 12-12z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#j)",
    opacity: 0.078,
    d: "M225 11h215.354v428H225z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetNeptune);
export default __webpack_public_path__ + "static/media/planet-neptune.af32296149ca9824ac1aa92201a6be37.svg";
export { ForwardRef as ReactComponent };